export default "__VITE_ASSET__CQkz$sDP__"